import React from "react";

type Props = {
    height: number;
    width: number;
};

export const AcxLoadingIcon = ({ height, width }: Props) => (
    <svg
        width={width}
        height={height}
        viewBox={`0 0 232 120`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M130.812 74.8673C123.76 81.9199 123.759 93.3531 130.81 100.404C137.861 107.455 149.294 107.454 156.347 100.402L211.558 45.1904C218.611 38.1378 218.612 26.7047 211.561 19.6537C204.51 12.6028 193.077 12.6033 186.024 19.6559L130.812 74.8673ZM127.396 103.818C118.459 94.8813 118.46 80.3908 127.398 71.4529L182.61 16.2415C191.547 7.30367 206.038 7.30226 214.975 16.2394C223.912 25.1765 223.911 39.667 214.973 48.6048L159.761 103.816C150.824 112.754 136.333 112.755 127.396 103.818Z"
            fill="#30CAAF"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.4419 74.8095C13.3893 81.862 13.3888 93.2952 20.4398 100.346C27.4907 107.397 38.9239 107.397 45.9764 100.344L101.188 45.1325C108.24 38.08 108.241 26.6468 101.19 19.5959C94.1391 12.5449 82.7059 12.5454 75.6533 19.598L20.4419 74.8095ZM17.0254 103.76C8.08828 94.8234 8.08971 80.3329 17.0275 71.3951L72.239 16.1836C81.1768 7.24581 95.6673 7.24438 104.604 16.1815C113.542 25.1186 113.54 39.6091 104.602 48.5469L49.3908 103.758C40.453 112.696 25.9625 112.698 17.0254 103.76Z"
            fill="#6F95F4"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M101.218 19.604C94.1651 12.5514 82.7319 12.5509 75.681 19.6019C68.63 26.6528 68.6305 38.086 75.6831 45.1385L130.895 100.35C137.947 107.403 149.38 107.403 156.431 100.352C163.482 93.3012 163.482 81.868 156.429 74.8155L101.218 19.604ZM72.2666 16.1875C81.2037 7.25039 95.6942 7.25182 104.632 16.1896L159.843 71.4011C168.781 80.3389 168.783 94.8294 159.846 103.767C150.908 112.704 136.418 112.702 127.48 103.764L72.2687 48.5529C63.3309 39.6151 63.3295 25.1246 72.2666 16.1875Z"
            fill="#FF835E"
        />
    </svg>
);
